import { getAuthToken } from 'store/auth/accessors';
import { deleteTokenOperation, setTokenOperation } from 'store/auth/operations';

export const getToken = () => {
    return getAuthToken();
};

export const removeToken = (): void => {
    deleteTokenOperation();
};

export const setToken = (token: string): void => {
    setTokenOperation(token);
};
